export default {
  src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
  autoBlockSrc:
    'https://cdn.cookielaw.org/consent/018fe359-4b18-76c4-839b-3dae0c8d6523/OtAutoBlock.js',
  domainScript: '018fe359-4b18-76c4-839b-3dae0c8d6523',
};
